import { gql } from "@apollo/client";

export const LISTING_TEMP_DATA_IMPORTS = gql`
query($payload: PageCountInput!,$columnFilters:TempBillingImportsColumnFilter) {
  dataImportTempBillings(payload: $payload,columnFilters:$columnFilters) {
    dataImports {
      id
      reportMetaId
      fileName
      fileLink
      reportType
      monthYr
      createdAt
      deleteBlocked
      uploadedBy {
        fullName
      }
    }
    count
    message
    status
  }
}`

export const CREATE_TEMP_BILLING_IMPORT = gql`
mutation($input: CreateDataImportTempBillingInput!) {
  createDataImportTempBilling(createDataImportTempBillingInput: $input) {
    message
    status
  }
}`

export const RECRUITER_AGENCY_WEEKLY_ACTIVITY_SHEET = gql`
query($metaDataId: String!) {
  recruiterAgencyWeeklyActivitySheet(metaDataId: $metaDataId) {
    rows {
      id
      companyName
      placementId
      candidateName
      invoiceDate
      invoiceNumber
      periodEndDate
      invoiceAmount
      grossWage
      payType
      units
      payRate
      billRate
      placementJobTitle
      candidateStateCode
      jobStateCode
      amNames
      recruiterNames
      matched
    }
    message
    status
  }
}`

export const DELETE_TEMP_BILLING_IMPORT = gql`
mutation($id: String!) {
  deleteDataImportTempBilling(id: $id) {
    message
    status
  }
}`